function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M11.603 19.193l-8.207-8.06a.56.56 0 010-.803l8.207-8.06a1.313 1.313 0 000-1.88 1.371 1.371 0 00-1.914 0L.595 9.32a1.97 1.97 0 000 2.82l9.094 8.932c.529.52 1.386.52 1.914 0a1.313 1.313 0 000-1.88z",
  fill: "currentColor"
});

function SvgLeftArrowBold(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: "false",
    viewBox: "0 0 12 22",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgLeftArrowBold;